import AssetStatusList from "./AssetStatusList";
import AddEditAssetStatus from "./AddEditAssetStatus";
export {
    AssetStatusList,
    AddEditAssetStatus
}
export const assetStatusObj = {
    ownership: null,
    asset_status: null,
    sub_statuses: [],
    contract_statuses: [],
    remarks: null,
}